<template>
  <div>
    <a-modal
      title="跟进"
      v-model="visible"
      :confirmLoading="loading"
      :destroyOnClose="true"
      @ok="next"
      okText="下一步"
    >
      跟进类型：
      <a-radio-group @change="onChange" v-model="follow.follow_type">
        <a-radio :style="radioStyle" :value="1">正常跟进</a-radio>
        <a-radio :style="radioStyle" :value="2"
          >标黑（仅做评价用，“标黑”后不影响他人继续跟进）</a-radio
        >
        <a-radio :style="radioStyle" :value="3"
          >标无效（“标无效”的猎头将被移入“无效猎头”池！不能被继续跟进）</a-radio
        >
      </a-radio-group>
    </a-modal>
    <a-modal
      title="跟进"
      v-model="visibleTwo"
      :confirmLoading="loading"
      :destroyOnClose="true"
      @ok="save"
    >
      <a-form :form="form">
        <a-form-item
          label="跟进类别："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-radio-group
            :options="plainOptions"
            v-decorator="[
              'active_handle_type',
              { rules: [{ required: true, message: '请补充跟进类别！' }] }
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="跟进职位：" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
            <a-input
                v-decorator="['note', { rules: [{ required: true, message: 'Please input your note!' }] }]"
            />
        </a-form-item> -->
        <a-form-item
          label="跟进渠道："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-radio-group
            :options="plainOptionstwo"
            v-decorator="[
              'follow_channel',
              { rules: [{ required: true, message: '请补充跟进渠道！' }] }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="跟进内容："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            style="height: 100px;"
            placeholder="请填写跟进内容，限200字以内"
            :maxLength="200"
            autosize
            :rows="4"
            v-decorator="[
              'body',
              { rules: [{ required: true, message: '请补充跟进内容！' }] }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="猎头意愿评分："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-radio-group
            :options="plainOptionsthree"
            v-decorator="[
              'star',
              { rules: [{ required: true, message: '请补充猎头意愿！' }] }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="附加说明："
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-upload
            name="file"
            :multiple="true"
            :action="baseURL + '/common/file/upload'"
            :data="{ token: token }"
            v-decorator="[
              'attachments',
              {
                valuePropName: 'fileList',
                getValueFromEvent: normFile
              }
            ]"
          >
            <a-button>
              <a-icon type="upload" /> 请上传跟进证明，如录音、截图
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>

    <remark-modal ref="remarkModal" @ok="doRemark"></remark-modal>
    
  </div>
</template>
<script>
import Api from "@/api";
import debounce from "lodash/debounce";
import RemarkModal from "./mark-modal";
import { mapState } from "vuex";
let baseURL = process.env.VUE_APP_BASEURL;

const plainOptions = [
  { label: "做单", value: "1" },
  { label: "简历变现", value: "2" },
  { label: "职位变现", value: "3" }
];
const plainOptionstwo = [
  { label: "微信", value: "1" },
  { label: "电话", value: "2" },
  { label: "其他", value: "3" }
];
const plainOptionsthree = [
  { label: "一星", value: "1" },
  { label: "二星", value: "2" },
  { label: "三星", value: "3" },
  { label: "四星", value: "4" },
  { label: "五星", value: "5" }
];
export default {
  name: "DispatchBdModal",
  components: {
    RemarkModal
  },
  computed: {
    ...mapState(["token"])
  },
  props: {
    callback: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      baseURL: baseURL,
      form: this.$form.createForm(this),
      follow: {
        follow_type: 1,
        active_handle_type: 1
      },
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      plainOptions,
      plainOptionstwo,
      plainOptionsthree,
      record: {},
      loading: false,
      visible: false,
      visibleTwo: false,
      uid: "",
      headers: {
        authorization: "authorization-text"
      },
      file: []
    };
  },
  methods: {
    async doRemark(values, id, follow_type) {
      try {
        await Api.hunter.addRemark({ user_id: id, body: values, follow_type,  });
        this.$refs.remarkModal.close();
        this.callback && this.callback();
      } catch (e) {}
    },
    save() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log(values);
          console.log(this.file);
          this.loading = true;
          let params = {
            user_id: this.record.id,
            follow_type: this.follow.follow_type,
            active_handle_type: values.active_handle_type,
            follow_channel: values.follow_channel,
            body: values.body,
            star: values.star,
            attachments: JSON.stringify(this.file)
          }
          Api.hunter.addRemark(params).then( res => {
            this.callback && this.callback();
            this.visibleTwo = false;
            this.loading = false;
          })
        }
      });
    },
    normFile(info) {
      console.log("Upload event:", info);
      if (Array.isArray(info)) {
        return info;
      }
      const status = info.file.status;
      if (status === "done") {
        this.$message.success(`${info.file.name} 上传成功！`);
        this.file = [];
        info.fileList.forEach(item => {
          if (item.response && item.response.data) {
            this.file.push(item.response.data);
          }
        });
      } else if (status === "error") {
        this.$message.error(`${info.file.name} 上传失败！`);
      }
      return info && info.fileList;
    },
    next() {
      console.log(this.follow);
      if(this.follow.follow_type === 1) {
        this.visibleTwo = true;
      } else {
        this.$refs.remarkModal.show(this.record.id, this.follow.follow_type);
      }
      this.visible = false;
    },
    onChange(e) {
      console.log("radio checked", e.target.value);
    },
    onChange1(e) {
      console.log("radio checked", e.target.value);
    },
    handleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    show(record) {
      console.log(record, 'record')
      this.visible = true;
      this.record = record;
    },
    close() {
      this.visible = false;
    },
    onSelect(value) {
      this.uid = value;
    }
  }
};
</script>

<style scoped lang="scss"></style>
